import { getAuthAxiosBackend } from "../helpers/axios"

class SacrificeDataServices{

    get(id){
        return getAuthAxiosBackend().get('SacrificialData/getSacrificialData/' + id.toString())
    }

    getByPersonId(personId){
        return getAuthAxiosBackend().get('SacrificialData/getSacrificialDataByPersonId/' + personId)
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('SacrificialData/all', {params: data})
    }

    add(data){
        return getAuthAxiosBackend().post('SacrificialData/addSacrificialData', data)
    }

    edit(id, data){
        return getAuthAxiosBackend().put('SacrificialData/updateSacrificialData/' + id, data)
    }

    delete(id){
        return getAuthAxiosBackend().delete('SacrificialData/softDeleteSacrificialData/' + id.toString())
    }
}

export default new SacrificeDataServices()